module.exports = __webpack_public_path__ + "bd6e32c6c17d5681cdd88ba679a5d83a.svg";